<template>
  <section
    class="generic-list-container py-[42px] lg:py-21"
    :class="{
      'background-pattern-sand-100': props.backgroundColour === 'sand',
      'background-pattern-navy-500': props.backgroundColour === 'blue',
      'bg-white': props.backgroundColour === 'white',
    }"
  >
    <slot name="textWithImage" />
    <slot name="genericList" />
  </section>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    backgroundColour?: 'white' | 'blue' | 'sand';
  }>(),
  {
    backgroundColour: 'white',
  }
);
defineSlots<{
  textWithImage(): unknown;
  genericList(): unknown;
}>();
</script>

<style lang="scss" scoped>
.generic-list-container {
  // In the event a section is used within a container,
  // we need to remove the padding-block to avoid double padding
  :deep(.w-full > [class~='py-[42px]'][class~='lg:py-21']) {
    padding-block: 0;
  }

  :deep(.image-only) {
    padding: 0 0 var(--margin-lg) 0;
  }
}
</style>
